import { shareColumnsExtend, shareFormColumnsExtend } from '../share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'ActiveStorage::Blob',
    column_type: 'id',
  },
  created_at: {
    model_name: 'ActiveStorage::Blob',
    column_type: 'datetime',
  },
  signed_id: {
    model_name: 'ActiveStorage::Blob',
    column_type: 'string',
  },
  content_type: {
    model_name: 'ActiveStorage::Blob',
    column_type: 'string',
  },
  filename: {
    model_name: 'ActiveStorage::Blob',
    column_type: 'string',
  },
  byte_size: {
    model_name: 'ActiveStorage::Blob',
    column_type: 'integer',
  },
  url: {
    model_name: 'ActiveStorage::Blob',
    column_type: 'string',
  },
  tag_list: {
    model_name: 'ActiveStorage::Blob',
    column_type: 'tag',
  },
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
